import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';

import { authLink, getErrorLink, uploadLink, ErrorLinkProps } from './links';

interface ApolloClientOptions {
  errorLink?: ErrorLinkProps;
}

if (process.env.NODE_ENV !== 'production') {
  loadErrorMessages();
  loadDevMessages();
}

const getClient = (options: ApolloClientOptions) =>
  new ApolloClient({
    link: ApolloLink.from([
      getErrorLink(options?.errorLink),
      authLink,
      uploadLink,
    ]),
    cache: new InMemoryCache({
      typePolicies: {
        UserProgramModel: {
          keyFields: (object) => {
            return `${object.id}:${object.level ?? 'default'}`;
          },
        },
      },
    }),
    defaultOptions: {
      watchQuery: {
        nextFetchPolicy: 'cache-and-network',
      },
    },
  });

export default getClient;
